<template>
  <aside class='side-menu'>
    <div class="side-menu-inner">
      <slot></slot>
    </div>
  </aside>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped>
.side-menu {
  position: fixed;
  top: 0;
  height: 100%;
  width: 151px;
  background-color: #f6f6f9;
  border-right: 1px solid #ECECEC;
  overflow-x: hidden;
  overflow-y: auto;
  padding-bottom: 15px;
}
</style>
